import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Calendar: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M2 8H22M6 1V4M18 1V4M5 13H8M5 17H8M10.5 13H13.5M16 13H19M10.5 17H13.5M2 4H22V22H2V4Z'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default Calendar
